import { Input, InputRef } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import {
  ActivateCallback,
  useActivateCallback,
} from "src/types/ActivateCallback";

import { ZAttrMeta, ZStringDef } from "../ZAttrMeta";
import { ZAttrInput } from "./ZAttrComponent";

type PropsAttrEditInput = {
  attrMeta: ZAttrMeta;
  value: unknown;
  onChange?(newValue: unknown): void;
  disabled?: boolean;
  activateCallback?: ActivateCallback;
  component?: ZAttrInput;
  textCvt?(text: string): string;
  onBlur: () => void;
};

export const AttrEditInput: React.FC<PropsAttrEditInput> = observer((props) => {
  const {
    value,
    onChange,
    disabled,
    attrMeta,
    activateCallback,
    component,
    textCvt,
    onBlur,
  } = props;
  const attrType: ZStringDef | undefined =
    attrMeta.type.name === "string" ? attrMeta.type : undefined;
  const iref = useActivateCallback<InputRef>(activateCallback, (ref) => () => {
    ref?.focus();
  });
  const cvt = (text: string | null | undefined) => {
    if (!text) return undefined;
    return textCvt?.(text) ?? text;
  };
  return (
    <Input
      ref={iref}
      allowClear
      maxLength={attrType?.maxLength ?? undefined}
      value={value as string}
      onChange={(e) => onChange?.(e.currentTarget.value)}
      onBlur={onBlur}
      disabled={disabled}
      addonAfter={cvt(component?.addonAfter)}
      addonBefore={cvt(component?.addonBefore)}
    />
  );
});
